import Config from '@/common/Config'

export default {

    //批量获取字符串
    getBatchString : function(string, count){
        var s   = '';
        for(let i = 0; i < count; i++){
            s += string;
        }

        return s;
    },

    //克隆对象
    clone : function(object){
        return JSON.parse(JSON.stringify(object));
    },

    //路由
    route : function(anchor) {
        if(anchor){
            window.open('#' + anchor, '_self');
            return true;
        }else{
            return '';
        }
    },

    //去页面
    toUrl : function(url){
        window.open('/#' + url, '_self')
    },

    //去M2页面
    toM2Url : function(url){
        window.open(Config.m2_url + '/#' + url, '_blank')
    },

    toM2DownLoadUrl : function() {
        window.open(Config.m2_url + '/#/download', '_blank')
    },


    //去fjsg页面
    toFjsgUrl : function(url){
        window.open(Config.fjsg_url + '/#' + url, '_blank')
    },

    //去lapis页面
    toLapisUrl : function(url){
        window.open(Config.lapis_url + '/#' + url, '_blank')
    },

    //字符串裁剪
    stringCut : function(string, length, postfix){
        var postfix = postfix || '...'

        if(string.length > length){
            return string.substr(0, length) + postfix
        }else{
            return string
        }
    },

    //url参数获取
    getUrlParam : function(par){
        //获取当前URL
        var local_url = document.location.href; 
        //获取要取得的get参数位置
        var get = local_url.indexOf(par +"=");
        if(get == -1){
            return false;   
        }   
        //截取字符串
        var get_par = local_url.slice(par.length + get + 1);    
        //判断截取后的字符串是否还有其他get参数
        var nextPar = get_par.indexOf("&") > get_par.indexOf("#") ? 
            get_par.indexOf("&") :get_par.indexOf("#")
        if(nextPar != -1){
            get_par = get_par.slice(0, nextPar);
        }
        return get_par;
    },

    //唤起客服
    callAbbr : function(){
        window.open('http://wpa.qq.com/msgrd?v=3&uin=800185459&site=qq&menu=yes&from=message&isappinstalled=0', 'blank')
    }
}


// WEBPACK FOOTER //
// ./src/common/Common.js